import { cn } from "@app/lib/utils";
import { PortalsWrapper } from "@design-system/components/Portal";
import {
  Footer,
  Header,
  ScrollProgressBar,
} from "@design-system/layouts/CommonLayout";
import { CookieConsentBanner } from "@modules/cookies/components";
import { useLoaderData } from "@remix-run/react";
import { isApple } from "../utils";

export function CommonLayout({ children }: { children: React.ReactNode }) {
  useLoaderData();
  const isMac = isApple();

  return (
    <div className={cn(isMac ? "mac-font" : "not-italic")}>
      <ScrollProgressBar />
      <Header />
      <main>{children}</main>
      <Footer />
      <PortalsWrapper />
      <CookieConsentBanner />
    </div>
  );
}
